export function isProductNotificationEnabled(variant) {
  return variant.settings && variant.settings.notificationEnabled;
}
export function isProductNotificationEnabledWithDefault(defaultValue) {
  return variant => variant.settings && typeof variant.settings.notificationEnabled === 'boolean' && variant.settings.notificationEnabled || defaultValue;
}